import React, {useEffect, useState} from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import {BaseURL} from "../../API/API";

const LoginForm = () => {
    const navigate = useNavigate();
    const [userName,setUserName]=useState("");
    const [password,setPassword]=useState("");
    const [error,setError]=useState("")
    const [showPassword, setShowPassword] = useState(false);
    const togglePassword = () => setShowPassword(!showPassword);

    useEffect(()=>{
        const params = new URLSearchParams(window.location.search);
        const userName = params.get('userName');
        const password = params.get('password');
        LogInFun(userName,password);
    },[]);

    function LogInBtn() {
        LogInFun(userName,password);
    }
    function LogInFun(userName,password) {
        let form = new FormData();
        form.append('userName',userName);
        form.append('password',password);
        fetch(BaseURL + 'GM.php/LogIn', {
            method: 'POST',
            body: form
        })
            .then(res => res.text()) // Or use .json() if response is valid JSON
            .then(data => {
                try {
                    const parsedData = JSON.parse(data); // First level parse
                    if(JSON.parse(parsedData).length>0){
                        sessionStorage.setItem("data", parsedData);
                        navigate('/admin/home');
                    }else{
                        setError("Invalid UserName Or Password");
                    }
                } catch (e) {
                    console.error("Parsing error:", e);
                }
            })
            .catch(err => {
                console.error("Fetch error:", err);
            });
    }

    return (
        <div className="d-flex justify-content-center align-items-center vh-100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-5 col-12">
                        <div className="card p-4">
                            <h2 className="text-center mb-4">Login</h2>

                            {/* User ID Input */}
                            <div className="mb-3">
                                <label htmlFor="userId" className="form-label">User ID</label>
                                <input type="text" onChange={(e)=>{setUserName(e.target.value)}} id="userId" className="form-control" placeholder="Enter User ID" />
                            </div>

                            {/* Password Input with Toggle */}
                            <div className="mb-3">
                                <label htmlFor="password" className="form-label">Password</label>
                                <div className="input-group">
                                    <input
                                        onChange={(e)=>{setPassword(e.target.value)}}
                                        type={showPassword ? "text" : "password"}
                                        id="password"
                                        className="form-control"
                                        placeholder="Enter Password"
                                    />
                                    <button
                                        className="btn btn-outline-secondary"
                                        type="button"
                                        onClick={togglePassword}
                                    >
                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </button>
                                </div>
                            </div>
                            <p className="mt-2 mb-2 text-danger">
                                {error}
                            </p>
                            {/* Submit Button */}
                            <button onClick={LogInBtn} className="btn btn-primary w-100">Login</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginForm;
